import { type FC } from 'react'
import { UpsellFeatureItem } from '../../Common/UpsellFeatureItem'

export const OAuth2AppUpsellFeatures: FC = () => {
  return (
    <>
      <UpsellFeatureItem title='Natural-language queries' description='Ask anything about your clients and meetings and get answers grounded in real data.' />
      <UpsellFeatureItem title='Build anything' description='Create reports, presentations, and client-facing outputs directly in the tools you use.' />
      <UpsellFeatureItem title='Access to all apps' description='Access every app on the Ultimate plan, now and as we add more.' className='mb-3' />
    </>
  )
}
